import { defineStore } from 'pinia'
import axios from 'axios'

export const useUserStore = defineStore('user', {
  actions: {
    async login(email, password) {
      try {
        const response = await axios.post(
          `${import.meta.env.VITE_API_URL}/user/login`,
          { email, password },
          { headers: { 'Content-Type': 'application/json' } }
        );

        if (!(response.status >= 200 && response.status < 300)) {
          throw new Error('Credenciales inválidas');
        }

        const data = response.data;
        localStorage.setItem('token', data.value.token);
        localStorage.setItem('id', data.value.user.id);
        localStorage.setItem('name', data.value.user.name);
        localStorage.setItem("has_notifications", data.value.user.has_notifications)

        const roles = data.value.user.roles.map(role => role.name);

        if (roles.includes("superadmin")) {
          localStorage.setItem('role', "superadmin");
        } else {
          localStorage.setItem('role', JSON.stringify(roles));
        }
      } catch (err) {
        if (err.response) {
          const data = err.response.data;
          const error = new Error(data?.message || data?.value || 'Credenciales inválidas');
          // Cuenta sin contraseña: el backend ya ha enviado el correo de
          // restablecimiento; el login muestra el aviso en lugar del error.
          if (data?.code === 'password_reset_required') {
            error.code = 'password_reset_required';
          }
          throw error;
        }
        throw err;
      }
    }
  }
})
